import React from 'react';

import DashboardContentView from './DashboardContentView';
import DashboardWebsocket from './DashboardWebsocket';
import { SkyLink } from './SkyLink';
import { useMytaverseEvent } from '@core/dashboard/providers/MytaverseEventProvider/MytaverseEventProvider';

const DashboardContent = () => {
  const { isSkyLinkActive } = useMytaverseEvent();

  return (
    <>
      {isSkyLinkActive && <SkyLink />}
      <DashboardWebsocket />
      <DashboardContentView />
    </>
  );
};

export default DashboardContent;
